/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import WarningIcon from '@material-ui/icons/Warning';
import moment from 'moment';

// icon
import MdPhone from '@material-ui/icons/Phone';
import MailOutline from '@material-ui/icons/MailOutline';
import Home from '@material-ui/icons/Home';

// Replacement for CustomDatePickerComponent
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

// constants
import {SEX_OPTION, CARDIAC_DEVICE, STATE_LIST} from '../../constsnts/patientEnrollmentConstants'

// import custom components
import CustomTextField from '../Common/FormMUIWrapperComponents/CustomTextField';
import CustomSingleSelectComboBox from '../Common/FormMUIWrapperComponents/CustomSingleSelectComboBox';

// import constants
import { TEXT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomTextField/Constants';
import { SELECT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomSingleSelect/Constants';
import { MASK_3_2_4_NUMBER_PATTERN, MASK_3_3_4_NUMBER_PATTERN } from '../Common/MaskUtils/MaskPatterns';
import { DATE_TIME_PICKER_CONST } from '../Common/FormMUIWrapperComponents/CustomDateTimePicker/Constants';

// Import styles
import styles from "./PatientProfileForm.styles.module.css";
import CommonStyles from '../Common/CommonStyles.css';

/*************************************
State list was generated :
From :https://www23.statcan.gc.ca/imdb/p3VD.pl?Function=getVD&TVD=53971
On : 25th Sep 2021
*************************************/

const ADDRESS_PATIENT_PO_ERROR = 'Patient Address cannot be PO Box, APO, or FPO';
const ADDRESS_SHIPPING_PO_ERROR = 'Shipping Address cannot be PO Box, APO, or FPO';
const INVALID_SSN = 'Invalid SSN';
const INVALID_PHONE_NUMBER = 'Invalid Phone Number';
const INVALID_ZIP_CODE = 'Invalid Zip Code';
const INVALID_EMAIL = 'Must be a valid email address';

const PatientProfileForm = props => {
    let enrolledPatientData = useSelector(state => state.idtfPatientEnrollment.patientEnrollment && state.idtfPatientEnrollment.patientEnrollment.enrolledPatientData);
    const enrolledAddressData = useSelector(state => state.idtfPatientEnrollment.patientEnrollment && state.idtfPatientEnrollment.patientEnrollment.enrolledAddressData);
    const identifiersData = useSelector(
        state => state.idtfPatientEnrollment.patientEnrollment.searchIdentifiers,
      );

    const isEdit = useSelector(state => state.idtfPatientEnrollment.patientEnrollment.enrollEditMode);
    
    // state for keyboard input in datepicker
    const [selectedDate, handleDateChange] = useState(identifiersData && identifiersData.dob ? identifiersData.dob : null)

    const [formData, setFormData] = useState({
        lastName: !isEdit ? identifiersData && identifiersData.lastName : enrolledPatientData && enrolledPatientData.lastName ? enrolledPatientData.lastName : '',
        firstName: !isEdit ? identifiersData && identifiersData.firstName : enrolledPatientData && enrolledPatientData.firstName ? enrolledPatientData.firstName : '',
        middleName: !isEdit ? identifiersData && identifiersData.middleName : enrolledPatientData && enrolledPatientData.middleName ? enrolledPatientData.middleName : '',
        dob: !isEdit ? identifiersData && new Date(identifiersData.dob) : enrolledPatientData && new Date(enrolledPatientData.dob) ? new Date(enrolledPatientData.dob) : new Date(null), // date
        sex: enrolledPatientData && enrolledPatientData.sex ? SEX_OPTION.find((item)=> {if(item.value ==  enrolledPatientData.sex) {return item}}) : {}, // Dropdown, single select
        // socialSecurityNumber: !isEdit ? identifiersData && identifiersData.ssn : enrolledPatientData && enrolledPatientData.socialSecurityNumber ? enrolledPatientData.socialSecurityNumber : null,
        socialSecurityNumber: !isEdit ? identifiersData && identifiersData.ssn : enrolledPatientData && enrolledPatientData.socialSecurityNumber ? enrolledPatientData.socialSecurityNumber : null,
        phone: enrolledPatientData && enrolledPatientData.phone ? enrolledPatientData.phone.replace(/^(\+1)/g, '') : null,
        alternatePhone: enrolledPatientData && enrolledPatientData.alternatePhone ? enrolledPatientData.alternatePhone.replace(/^(\+1)/g, '') : null,
        customParticipantID: !isEdit ? identifiersData && identifiersData.mrn : enrolledPatientData && enrolledPatientData.customParticipantID ? enrolledPatientData.customParticipantID : '', // MRN
        email: enrolledPatientData && enrolledPatientData.email ? enrolledPatientData.email : '',
        emergencyContactName: enrolledPatientData && enrolledPatientData.emergencyContactName ? enrolledPatientData.emergencyContactName : '',
        emergencyContactPhone: enrolledPatientData && enrolledPatientData.emergencyContactPhone ? enrolledPatientData.emergencyContactPhone.replace(/^(\+1)/g, '') : null,
        implantedDevice: enrolledPatientData && enrolledPatientData.implantedDevice ? CARDIAC_DEVICE.find((item)=> {if(item.value ==  enrolledPatientData.implantedDevice) {return item}}) : CARDIAC_DEVICE.find((item)=> {if(item.value ==  'unknown') {return item}}),  // Radio
        patientAddressLine1: enrolledAddressData && enrolledAddressData.primary_address && enrolledAddressData.primary_address.primaryLine ? enrolledAddressData.primary_address.primaryLine : '',
        patientAddressLine2: enrolledAddressData && enrolledAddressData.primary_address && enrolledAddressData.primary_address.secondaryLine ? enrolledAddressData.primary_address.secondaryLine : '',
        patientCity: enrolledAddressData && enrolledAddressData.primary_address && enrolledAddressData.primary_address.city ? enrolledAddressData.primary_address.city : '',
        patientAddressState: enrolledAddressData && enrolledAddressData.primary_address && enrolledAddressData.primary_address.state ? STATE_LIST.find((item)=> {if(item.code ==  enrolledAddressData.primary_address.state) {return item}}) : {}, // Dropdown combobox
        patientZipCode: enrolledAddressData && enrolledAddressData.primary_address && enrolledAddressData.primary_address.postalCode ? enrolledAddressData.primary_address.postalCode : null,
        shippingAddressLine1: enrolledAddressData && enrolledAddressData.shipping_address && enrolledAddressData.shipping_address.primaryLine ? enrolledAddressData.shipping_address.primaryLine : '',
        shippingAddressLine2: enrolledAddressData && enrolledAddressData.shipping_address && enrolledAddressData.shipping_address.secondaryLine ? enrolledAddressData.shipping_address.secondaryLine : '',
        shippingCity: enrolledAddressData && enrolledAddressData.shipping_address && enrolledAddressData.shipping_address.city ? enrolledAddressData.shipping_address.city : '',
        patientAddressShippingState: enrolledAddressData && enrolledAddressData.shipping_address && enrolledAddressData.shipping_address.state ? STATE_LIST.find((item)=> {if(item.code ==  enrolledAddressData.shipping_address.state) {return item}}) : {},
        shippingZipCode: enrolledAddressData && enrolledAddressData.shipping_address && enrolledAddressData.shipping_address.postalCode ? enrolledAddressData.shipping_address.postalCode : null,
        note: enrolledPatientData && enrolledPatientData.note ? enrolledPatientData.note : '',
    });
    // Checkbox flag to use for copy same shipping address
    const [sameShippingAddress, setSameShippingAddress] = useState(false);
    // initial validation is false, so set error as true
    const [formErrorState, setFormErrorState] = useState(true)
    const {
        me,
        validateMainForm,
        formNameSpace,
    } = props

    // update text field data to state
    const handleFormDataUpdate = (e, stateKey, val) => {
        let value = '';
        if (e && e.target) {
            value = e.target.value
        }
        if (stateKey) {
            const tempFormData = { ...formData };
            switch (stateKey) {
                case 'sex':
                    // handle Patient's sex dd select
                    // let selectedS = SEX_OPTION.find(o => o.value === value);
                    if (val) {
                        tempFormData.sex = val;
                    }
                    break;
                // handle Patient's Address / Patient's Shipping  state dd select
                case 'patientAddressState':
                    if (sameShippingAddress) {
                        tempFormData.patientAddressShippingState = val
                    }
                case 'patientAddressShippingState':
                    if (val) {
                        tempFormData[stateKey] = val;
                    }
                    break;
                case 'patientAddressLine1':
                    tempFormData[stateKey] = value;
                    if (sameShippingAddress) {
                        tempFormData.shippingAddressLine1 = value
                    }
                    break;
                case 'patientAddressLine2':
                    tempFormData[stateKey] = value;
                    if (sameShippingAddress) {
                        tempFormData.shippingAddressLine2 = value
                    }
                    break;
                case 'patientCity':
                    tempFormData[stateKey] = value;
                    if (sameShippingAddress) {
                        tempFormData.shippingCity = value
                    }
                    break;
                case 'patientZipCode':
                    tempFormData[stateKey] = value;
                    if (sameShippingAddress) {
                        tempFormData.shippingZipCode = value
                    }
                    break;
                case 'dob':
                    if (selectedDate) {
                        tempFormData[stateKey] = new Date(selectedDate);
                    }
                    break;
                case 'implantedDevice':
                    tempFormData.implantedDevice = val
                    break;
                case 'socialSecurityNumber':
                case 'lastName':
                case 'firstName':
                case 'middleName':
                case 'phone':
                case 'alternatePhone':
                case 'customParticipantID':
                case 'email':
                case 'emergencyContactName':
                case 'emergencyContactPhone':
                case 'implantedDevice':
                case 'shippingAddressLine1':
                case 'shippingAddressLine2':
                case 'shippingCity':
                case 'shippingZipCode':
                case 'note':
                    tempFormData[stateKey] = value;
                default:
                    break;
            }
            setFormData(tempFormData)
        }
    }

    // Function to handle Datepickr change(on keyboard input also)
    const handleDOBChange = (date) => {
        const tempFormData = { ...formData };

        // store undefined in formdata.dob in case of Invalid Date
        if(date == null || date.toString() == 'Invalid Date'){
            tempFormData["dob"] = 'undefined';
        }
        tempFormData["dob"] = date;

        setFormData(tempFormData)
        handleDateChange(date) // change local state selectedDate (for Keyboard input)
        validateForm(true) //For date validation on change
    }

    // copy Patient's Address to Shipping address on checked select
    const handleChangeSameShippingAddress = (e) => {
        setSameShippingAddress(e.target.checked)
        if (e.target.checked) {
            copySameShippingAddress()
        }
    }

    const copySameShippingAddress = () => {
        const tempFormData = { ...formData };
        tempFormData.shippingAddressLine1 = tempFormData.patientAddressLine1;
        tempFormData.shippingAddressLine2 = formData.patientAddressLine2;
        tempFormData.shippingCity = formData.patientCity;
        tempFormData.shippingZipCode = formData.patientZipCode;
        tempFormData.patientAddressShippingState = formData.patientAddressState;
        setFormData(tempFormData);
    }

    // validate address POBox
    const validateAddressPOBox = (e, forceStateChange = false) => {
        let valid = true;
        let valueToLCase = '';
        if (forceStateChange) {
            valueToLCase = e.toLowerCase();
        } else {
            const { value } = e.target;
            valueToLCase = value.toLowerCase();
        }
        const CASES = ['po box', 'pobox', 'p.o.box', 'po. box', 'p.o. box', 'p. o. box', 'p.o box',
            'p.o. box', 'post office box', 'apo', 'Army Post Office', 'Army PO', 'fpo', 'Fleet Post Office',
        ];
        CASES.forEach(element => {
            if (valueToLCase.search(`\\b${element.toLowerCase()}\\b`) >= 0) {
                valid = false;
                return;
            }
        });
        return valid;
    }

    function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
      }
    // validate Form state
    const validateForm = (state) => {
        // if state true, means error, so update state
        if (state) {
            setFormErrorState(state)
        } else {
            // check if all required field is filled 
            // check all date cases (invalid, undefined, null, greater than today)
            if ( formData.customParticipantID !== '' && formData.lastName !== '' && formData.firstName !== '' && !_.isEmpty(formData.sex) && (formData.dob && formData.dob.toString() != 'Invalid Date' && formData.dob !== 'undefined' && formData.dob != null && moment(formData.dob).isBefore(moment()))
                && formData.phone !== null && formData.implantedDevice !== '' && formData.patientAddressLine1 !== '' && formData.patientCity !== ''
                && !_.isEmpty(formData.patientAddressState) && formData.patientZipCode != null && formData.shippingAddressLine1 !== ''
                && formData.shippingCity !== '' && !_.isEmpty(formData.patientAddressShippingState) && formData.shippingZipCode != null) {
                // console.log('error log', formData.dob)
                setFormErrorState(false)
            }
        }
    }

    // validate socialSecurityNumber length
    const validateSSN = (e) => {
        let valid = true;
        let value = '';
        if (e && e['target']) {
            value = e.target.value
        } else if (e && !e.target) {
            value = e;
        }
        if (value) {
            // in older browsers as Chrome77 JS Function replaceAll('-', '/') not working, replacing the replaceAll function with replace
            // const ssnStr = value.replaceAll('-', '')
            const ssnStr = value.replace(/-/g, '')
            if (ssnStr.length === 9) {
                valid = true
            } else {
                valid = false
            }
        }
        return valid
    }

    // validate socialSecurityNumber length
    const validatePhoneNumber = (e) => {
        let valid = true;
        let value = '';
        if (e && e['target']) {
            value = e.target.value
        } else if (e && !e.target) {
            value = e;
        }
        if (value) {
            // in older browsers as Chrome77 JS Function replaceAll('-', '/') not working, replacing the replaceAll function with replace
            // const phnStr = value.replaceAll('-', '')
            const phnStr = value.replace(/-/g, '')
            if (phnStr.length === 10) {
                valid = true
            } else {
                valid = false
            }
        }
        return valid
    }

    // validate socialSecurityNumber length
    const validateZipCode = (e) => {
        let valid = true;
        let value = '';
        if (e && e['target']) {
            value = e.target.value
        } else if (e && !e.target) {
            value = e;
        }
        if (value) {
            if (value.length === 5) {
                valid = true
            } else {
                valid = false
            }
        }
        return valid
    }

    // validate email
    const validateEmail = (e) => {
        let valid = true;
        let value = '';
        if (e && e['target']) {
            value = e.target.value
        } else if (e && !e.target) {
            value = e;
        }
        if (value) {
            if (/^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
                valid = true
            } else {
                valid = false
            }
        }
        return valid
    }

    useEffect(() => {
        // if form data is updated, pass the updated data to Parent form with error state
        validateMainForm(formNameSpace, formErrorState, formData);
    }, [formData])

    // on change of errorState of form
    useEffect(() => {
        validateMainForm(formNameSpace, formErrorState, formData);
    }, [formErrorState])

    // on change of errorState of form
    useEffect(() => {
        // on change of radio button make validateForm call validate
        validateForm(false)
    }, [formData.implantedDevice])

    // on change of errorState of form
    useEffect(() => {
        // on change of date change in DOB make validateForm call validate
        validateForm(false)
    }, [formData.dob])

    return (
        <div className={styles.pageContainer}>
            <h1 className={styles.title}>Patient Profile</h1>
            <div style= {{ marginTop: '-30px', marginBottom: '30px', fontSize: 'large'}}>{isEdit ? <p>Call Customer Support at 1-833-525-1400 to change the Patient Identifier or Name in an existing patient profile.</p> : ''}</div>
            <Grid container spacing={2}>
                {/* ============= Start of Grid ============= */}
                {/* Basic Details section */}
                {/* Last Name */}
                <Grid item xs={4}>
                    <CustomTextField
                        disabled={isEdit && enrolledPatientData && enrolledPatientData.lastName != ''}
                        label="Last Name"
                        mandatory={true}
                        // placeholder='Enter Last Name'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        value={formData.lastName}
                        stateKey='lastName'
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* First Name */}
                <Grid item xs={4}>
                    <CustomTextField
                        disabled={isEdit && enrolledPatientData && enrolledPatientData.firstName != ''}
                        label="First Name"
                        // placeholder='Enter First Name'
                        mandatory={true}
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        value={formData.firstName}
                        stateKey='firstName'
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                <Grid item xs={4}>
                    {/* Middle Name or Initial */}
                    <CustomTextField
                        disabled={isEdit && enrolledPatientData && enrolledPatientData.middleName != ''}
                        label="Middle Name"
                        // placeholder='Enter Middle Name or Initial'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        value={formData.middleName}
                        stateKey='middleName'
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* DOB */}
                <Grid item xs={6}>
                    {/* <CustomDateTimePicker
                        label=' Date of Birth'
                        variant={DATE_TIME_PICKER_CONST.VARIANT.DATE}
                        value={formData.dob}
                        inputFormat='MM-DD-YYYY'
                        mandatory={true}
                        stateKey='dob'
                        maxDate={moment()}
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    /> */}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <InputLabel shrink >
                            <label className={styles.label}>
                            Date Of Birth
                            </label>
                            <label className={CommonStyles.asterisk}>&#x2a;
                            </label>
                        </InputLabel>
                        <KeyboardDatePicker
                            autoOk
                            disableFuture
                            disabled={isEdit}
                            style={{ marginTop: '8px' }}
                            openTo="year"
                            variant="inline"
                            size="small"
                            inputVariant="outlined"
                            format="MM-dd-yyyy"
                            margin="normal"
                            placeholder="MM-DD-YYYY"
                            id="dob"
                            views={["year", "month", "date"]}
                            value={isEdit ? formData.dob : selectedDate}
                            onChange={date => {handleDOBChange(date)}}
                            inputVariant="outlined"
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            fullWidth
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                {/* SEX */}
                <Grid item xs={6}>
                    <CustomSingleSelectComboBox
                        label="Sex"
                        placeholder='Select Sex'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={SEX_OPTION}
                        valueKey='value'
                        labelKeys={['label']}
                        // labelKeys={['label', 'value',]}
                        // labelDisplayPrefix='Dr.'
                        // labelDisplaySeparator=' / '
                        mandatory={true}
                        selectedValue={formData.sex}
                        stateKey='sex'
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Primary Phone Number */}
                <Grid item xs={6}>
                    <CustomTextField
                        label="Primary Phone Number"
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        mandatory={true}
                        // placeholder='000-000-0000'
                        maskInput={MASK_3_3_4_NUMBER_PATTERN}
                        icon={<MdPhone />}
                        value={formData.phone}
                        stateKey='phone'
                        errorText={INVALID_PHONE_NUMBER}
                        validation={validatePhoneNumber}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Alternate Phone Number */}
                <Grid item xs={6}>
                    <CustomTextField
                        label="Alternate Phone Number"
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        // placeholder='000-000-0000'
                        maskInput={MASK_3_3_4_NUMBER_PATTERN}
                        icon={<MdPhone />}
                        value={formData.alternatePhone}
                        stateKey='alternatePhone'
                        errorText={INVALID_PHONE_NUMBER}
                        validation={validatePhoneNumber}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* MRN */}
                <Grid item xs={6}>
                    <CustomTextField
                        disabled={isEdit}
                        label="MRN"
                        // placeholder='Enter MRN'
                        mandatory={true}
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        value={formData.customParticipantID}
                        stateKey='customParticipantID'
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* socialSecurityNumber */}
                <Grid item xs={6}>
                    <CustomTextField
                        disabled={isEdit && enrolledPatientData && enrolledPatientData.socialSecurityNumber != ''}
                        label="SSN"
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        // placeholder='000-00-0000'
                        maskInput={MASK_3_2_4_NUMBER_PATTERN}
                        value={formData.socialSecurityNumber}
                        stateKey='socialSecurityNumber'
                        errorText={INVALID_SSN}
                        validation={validateSSN}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>

                {/* Email section */}
                {/* Email */}
                <Grid item xs={12}>
                    <CustomTextField
                        label="Email"
                        // placeholder='Enter patient email'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        icon={<MailOutline />}
                        // mandatory={true}
                        errorIcon = {<WarningIcon style={{ fill: '#f44336'}}/>}
                        value={formData.email}
                        stateKey='email'
                        errorText={INVALID_EMAIL}
                        validation={validateEmail}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Emergency section */}
                {/* Emergency Contact Name */}
                <Grid item xs={6}>
                    <CustomTextField
                        label="Emergency Contact Name"
                        // placeholder='Enter emergency contact name'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        value={formData.emergencyContactName}
                        stateKey='emergencyContactName'
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Emergency Contact Phone Number */}
                <Grid item xs={6}>
                    <CustomTextField
                        label="Emergency Contact Phone Number"
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        // placeholder='000-000-0000'
                        maskInput={MASK_3_3_4_NUMBER_PATTERN}
                        // icon={<MdPhone />}
                        value={formData.emergencyContactPhone}
                        stateKey='emergencyContactPhone'
                        errorText={INVALID_PHONE_NUMBER}
                        validation={validatePhoneNumber}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Implant devices section */}
                {/* Cardiac Implanted Device */}
                {/* <Grid item xs={6}>
                    <CustomRadioGroup
                        mandatory={true}
                        label="Cardiac Implanted Device"
                        color="primary"
                        size={RADIO_FIELD_CONST.SIZE.MEDIUM}
                        options={CARDIAC_DEVICE}
                        value={formData.implantedDevice}
                        valueKey='value'
                        labelKey='label'
                        stateKey='implantedDevice'
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid> */}
                
                <Grid item xs={12}>
                    <h1 className={styles.heading}>Cardiac Implanted Device</h1>
                    <CustomSingleSelectComboBox
                        label="Cardiac Implanted Device Type"
                        placeholder='Select Device'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={CARDIAC_DEVICE}
                        mandatory={true}
                        valueKey='value'
                        labelKeys={['label']}
                        stateKey='implantedDevice'
                        selectedValue={formData.implantedDevice}
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid>

                <Grid item xs={12}>
                  <h1 style={{marginBottom: '-5px'}} className={styles.heading}>Patient Address Information</h1>
                </Grid>
                {/* Patient Address section */}
                {/* Patient Address Line 1 */}
                <Grid item xs={12}>
                    <CustomTextField
                        label="Address - Line 1"
                        // placeholder='Enter address line 1'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        mandatory={true}
                        value={formData.patientAddressLine1}
                        stateKey='patientAddressLine1'
                        // icon={<Home />}
                        errorText={ADDRESS_PATIENT_PO_ERROR}
                        validation={validateAddressPOBox}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Patient Address Line 2 */}
                <Grid item xs={12}>
                    <CustomTextField
                        label="Address - Line 2"
                        // placeholder='Enter address line 2'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        value={formData.patientAddressLine2}
                        stateKey='patientAddressLine2'
                        errorText={ADDRESS_PATIENT_PO_ERROR}
                        validation={validateAddressPOBox}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Patient City */}
                <Grid item xs={4}>
                    <CustomTextField
                        label="City"
                        // placeholder='Enter city'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        mandatory={true}
                        value={formData.patientCity}
                        stateKey='patientCity'
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Patient State */}
                <Grid item xs={4}>
                    <CustomSingleSelectComboBox
                        label="State"
                        placeholder='Select State'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={STATE_LIST}
                        mandatory={true}
                        valueKey='code'
                        labelKeys={['name', 'code']}
                        labelDisplaySeparator=' -'
                        // labelDisplayPrefix='Dr.'
                        // labelDisplaySeparator=' == '
                        stateKey='patientAddressState'
                        selectedValue={formData.patientAddressState}
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Patient Zip Code */}
                <Grid item xs={4}>
                    <CustomTextField
                        label="Zip Code"
                        mandatory={true}
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        maxlength={5}
                        // placeholder='00000'
                        value={formData.patientZipCode}
                        stateKey='patientZipCode'
                        errorText={INVALID_ZIP_CODE}
                        validation={validateZipCode}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>

                {/* Shipping Address Information */}
                <Grid item xs={12}>
                  <h1 style={{marginBottom: '-5px'}} className={styles.heading}>Shipping Address Information</h1>
                </Grid>

                {/* Address copy checkbox */}
                <Grid item xs={12}>
                    {/* <InputLabel shrink >
                        Shipping Address (Cannot be P.O Box or F.P.O)
                    </InputLabel> */}
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={sameShippingAddress}
                                onChange={handleChangeSameShippingAddress}
                            />}
                        label="Same as Patient Address"
                    />
                </Grid>

                {/* Shipping Address section */}
                {/* Shipping Address Line 1 */}
                {<Grid container spacing={2} style={{marginLeft: '2px', marginRight: '2px', display : sameShippingAddress ? 'none' : 'flex'}}>
                <Grid item xs={12}>
                    <CustomTextField
                        label="Shipping Address - Line 1"
                        // placeholder='Enter shipping address line 1'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        mandatory={true}
                        value={formData.shippingAddressLine1}
                        stateKey='shippingAddressLine1'
                        disabled={sameShippingAddress}
                        // icon={<MailOutline />}
                        labelHelperText={`Shipping Address cannot be PO Box, APO, or FPO`}
                        errorText={ADDRESS_SHIPPING_PO_ERROR}
                        validation={validateAddressPOBox}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Shipping Address Line 2 */}
                <Grid item xs={12}>
                    <CustomTextField
                        label="Address - Line 2"
                        // placeholder='Enter shipping address line 2'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        value={formData.shippingAddressLine2}
                        stateKey='shippingAddressLine2'
                        disabled={sameShippingAddress}
                        errorText={ADDRESS_SHIPPING_PO_ERROR}
                        validation={validateAddressPOBox}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Shipping City */}
                <Grid item xs={4}>
                    <CustomTextField
                        label="City"
                        // placeholder='Enter city'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        mandatory={true}
                        value={formData.shippingCity}
                        stateKey='shippingCity'
                        disabled={sameShippingAddress}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Shipping State */}
                <Grid item xs={4}>
                    <CustomSingleSelectComboBox
                        label="State"
                        placeholder='Select State'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={STATE_LIST}
                        mandatory={true}
                        valueKey='code'
                        labelKeys={['name', 'code']}
                        labelDisplaySeparator=' -'
                        stateKey='patientAddressShippingState'
                        selectedValue={formData.patientAddressShippingState}
                        disabled={sameShippingAddress}
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* Shipping Zip Code */}
                <Grid item xs={4}>
                    <CustomTextField
                        label="Zip Code"
                        mandatory={true}
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        type={TEXT_FIELD_CONST.TYPE.TEL}
                        maxlength={5}
                        // placeholder='00000'
                        value={formData.shippingZipCode}
                        stateKey='shippingZipCode'
                        errorText={INVALID_ZIP_CODE}
                        disabled={sameShippingAddress}
                        validation={validateZipCode}
                        validateForm={validateForm}
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                </Grid>}
                {/* Note */}
                <Grid item xs={12}>
                    <CustomTextField
                        label="Notes"
                        // placeholder='Enter notes'
                        size={TEXT_FIELD_CONST.SIZE.SMALL}
                        rows={1}
                        maxlength={10000}
                        value={formData.note}
                        stateKey='note'
                        onChange={handleFormDataUpdate}
                    />
                </Grid>
                {/* ============= End of Grid ============= */}
            </Grid>
        </div>
    );
}

export default PatientProfileForm


// WEBPACK FOOTER //
// ./src/views/components/PatientProfileForm/PatientProfileForm.jsx